<template>
  <div>
    <el-dialog
      :visible.sync="dialogCodeVisible"
      top="2%"
      @close="handleClose"
      width="40%"
    >
      <span slot="title">获取电子处方</span>
      <div class="get-content" v-loading="loading">
        <div class="get-checkbox">
          <el-checkbox-group v-model="checkboxGroup1" size="small">
            <div class="get-checkbox-item" v-for="v in platforms" :key="v.text">
              <el-checkbox :label="v.value" :disabled="!v.isEnabled">
                <span>{{ v.text }}</span>
                <span style="color: #909399"
                  >(上次获取时间：{{ v.savedTime }})</span
                >
              </el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
        <div class="get-button">
          <el-button plain size="mini" @click="dialogCodeVisible = false"
            >取消</el-button
          >
          <el-button type="primary" size="mini" @click="handleSubmit"
            >保存并获取</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "GetOrder",
  components: {},
  props: {},
  data() {
    return {
      loading: false,
      dialogCodeVisible: false,
      checkboxGroup1: [],
      platforms: [],
    };
  },
  methods: {
    handleClose() {
      this.dialogCodeVisible = false;
    },
    async show() {
      this.dialogCodeVisible = true;
      this.loading = true;
      const { data } = await this.$api.prescription.GetPrescriptionPlatforms();
      this.loading = false;
      this.platforms = data || [];
      this.platforms.forEach((item) => {
        if (item.isChecked) {
          this.checkboxGroup1.push(item.value);
        }
      });
    },
    async handleSubmit() {
      if (this.checkboxGroup1.length === 0) {
        this.$notify({
          title: "注意",
          type: "error",
          message: "请选择获取电子处方的平台",
          position: "bottom-right",
          duration: 4000,
          customClass: "notify-error-title",
        });
        return;
      }
      let subArray = [];
      this.platforms.forEach((item) => {
        if (this.checkboxGroup1.includes(item.value)) {
          subArray.push(item);
        }
      });
      this.loading = true;
      await this.$api.prescription.SetPrescriptionPlatform({
        platforms: subArray,
      });
      this.loading = false;
      this.dialogCodeVisible = false;
      this.$emit("submit");
    },
  },
};
</script>

<style scoped>
::v-deep .el-dialog__header {
  background: #f7f7f7 !important;
  border-radius: 4px 4px 0px 0px !important;
  border-bottom: 1px solid #dcdcdc !important;
}
</style>
<style lang="scss" scoped>
@import "./getOrder.scss";
</style>
